import React from "react";
import { LineSeperator } from "../../../../components/RegularComponents";
import { INTERNAL_NOTES_TAB } from "../InformationDetailPanel";
import { AddInternalNote } from "./Information/AddInternalNote";
import { InternalNotes } from "./Information/InternalNotes";

export const InternalNotesTab = (props) => {
    const { internalNoteCategory } = props;

    return (
        <div style={{ marginTop: "3em" }}>
            {internalNoteCategory !== INTERNAL_NOTES_TAB && (<>
                <AddInternalNote {...props} />
                <LineSeperator />
            </>)}
            

            <InternalNotes {...props} />
        </div>
    )
}